import { useEffect, useState } from 'react';
import { loggedIn } from "../components/common";
// import { NewSiteWizard } from "../components/new-site-wizard";
import { subDatabasesBreadcrumbs } from "../components/common";

import { useNavigate } from 'react-router-dom';
import { NewDatabaseForm } from "../components/new-database-form";

import {
  BreadcrumbGroup,
} from '@cloudscape-design/components';

import '../css/base.scss';

const Breadcrumbs = ({navigate, item}) => (
  <BreadcrumbGroup
    onFollow={event => {
      event.preventDefault();
      navigate(event.detail.href);
    }}
    items={subDatabasesBreadcrumbs(item)}
    expandAriaLabel="Show path"
    ariaLabel="Breadcrumbs" />
)

export default function NewDatabase({ state }) {
  const navigate = useNavigate();
  if (!loggedIn()) {
    return null;
  }
  useEffect(() => {
    state.activeHref.setHref("/databases");
    state.breadCrumbs.setCrumbs(
      <Breadcrumbs navigate={navigate} item="Create Database" />
    )
    state.maxContentWidth.setWidth(Number.MAX_VALUE);
    state.contentType.setType("default");
  }, []);
  return (
      <NewDatabaseForm resource="Database" url="dbhosts" flashbar={state.flashBar}/>
  );
}
